var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { RendererFactory } from "survey-core";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { SurveyQuestionBoolean } from "./boolean";
import { TitleActions } from "./components/title/title-actions";
import { SurveyElementBase } from "./reactquestion_element";
var SurveyQuestionBooleanCheckbox = /** @class */ (function (_super) {
    __extends(SurveyQuestionBooleanCheckbox, _super);
    function SurveyQuestionBooleanCheckbox(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionBooleanCheckbox.prototype.renderElement = function () {
        var cssClasses = this.question.cssClasses;
        var itemClass = this.question.getCheckboxItemCss();
        var description = this.question.canRenderLabelDescription ?
            SurveyElementBase.renderQuestionDescription(this.question) : null;
        return (React.createElement("div", { className: cssClasses.rootCheckbox },
            React.createElement("div", { className: itemClass },
                React.createElement("label", { className: cssClasses.checkboxLabel },
                    React.createElement("input", { ref: this.checkRef, type: "checkbox", name: this.question.name, value: this.question.booleanValue === null
                            ? ""
                            : this.question.booleanValue, id: this.question.inputId, className: cssClasses.controlCheckbox, disabled: this.question.isDisabledAttr, readOnly: this.question.isReadOnlyAttr, checked: this.question.booleanValue || false, onChange: this.handleOnChange, "aria-required": this.question.a11y_input_ariaRequired, "aria-label": this.question.a11y_input_ariaLabel, "aria-labelledby": this.question.a11y_input_ariaLabelledBy, "aria-describedby": this.question.a11y_input_ariaDescribedBy, "aria-invalid": this.question.a11y_input_ariaInvalid, "aria-errormessage": this.question.a11y_input_ariaErrormessage }),
                    React.createElement("span", { className: cssClasses.checkboxMaterialDecorator },
                        this.question.svgIcon ?
                            React.createElement("svg", { className: cssClasses.checkboxItemDecorator },
                                React.createElement("use", { xlinkHref: this.question.svgIcon })) : null,
                        React.createElement("span", { className: "check" })),
                    this.question.isLabelRendered && (React.createElement("span", { className: cssClasses.checkboxControlLabel, id: this.question.labelRenderedAriaID },
                        React.createElement(TitleActions, { element: this.question, cssClasses: this.question.cssClasses })))),
                description)));
    };
    return SurveyQuestionBooleanCheckbox;
}(SurveyQuestionBoolean));
export { SurveyQuestionBooleanCheckbox };
ReactQuestionFactory.Instance.registerQuestion("sv-boolean-checkbox", function (props) {
    return React.createElement(SurveyQuestionBooleanCheckbox, props);
});
RendererFactory.Instance.registerRenderer("boolean", "checkbox", "sv-boolean-checkbox");
